import React, {useState, useEffect} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  Alert,
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import moment from 'moment';
import { connect } from "react-redux"

// import CreatableSelect from 'react-select/creatable';
import TagsInput from 'react-tagsinput'

import 'react-tagsinput/react-tagsinput.css' // If using WebPack and style-loader.




const NewForm = props => {

  const history = useHistory();

  const [loading, setLoading] = React.useState(true);
  const [errors, setErrors] = React.useState([]);
  
  const [name, setName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [documentNumber, setDocumentNumber] = React.useState('');
  const [revisionNumber, setRevisionNumber] = React.useState('');
  const [revisionDate, setRevisionDate] = React.useState(moment().format('YYYY-MM-DD'));
  
  const [fields, setFields] = React.useState([
    {
      label: "",
      type: "text",
      fieldoptions: [], 
      selectedOptions: []
    }
  ]);
  const [selectOptions, setSelectOptions] = React.useState([
    {label: 'Yes'}, 
    {label: 'No'}, 
    {label: 'Pending'},
    {label: 'Completed'}, 
  ]);
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  
  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_FORM+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        let finals = response.data.fields.map(it => {
          let orig = [];
          if(it.options) {
            orig = it.options.split(',');
          }
          if(orig.length == 1 && orig[0]=='') {
            orig = [];
          }
          return {
            label: it.label, 
            type: it.type, 
            fieldoptions: orig, 
            selectedOptions: orig,
            min: it.min, 
            max: it.max, 
            warning_min: it.warning_min, 
            warning_max: it.warning_max, 
            unit_of_measure: it.unit_of_measure, 
            alert_on: it.alert_on == null ? 'null' : it.alert_on, 
          };
        });
        console.log('OD', finals);
        setFields(finals);
        setName(response.data.form.name);
        setDescription(response.data.form.description);
        setDocumentNumber(response.data.form.document_number);
        setRevisionNumber(response.data.form.revision_number);
        setRevisionDate(response.data.form.revision_date);
        
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch form data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  useEffect(()=>{
    if(props.match.params.id && props.match.params.id !== 'new') {
      fetchData(props.match.params.id);
    }
  }, []);


  const addRow = () => {
    let newFields = JSON.parse(JSON.stringify(fields));
    newFields.push({
      label: "",
      type: "text",
      fieldoptions: [], 
      selectedOptions: []
      });
      setFields(newFields);
  }

  const deleteRow = (index) => {
    let temp = JSON.parse(JSON.stringify(fields));
    temp.splice(index,1);
    setFields(temp);
  }



  const moveUp = (index) => {
    let tempArr = JSON.parse(JSON.stringify(fields));
    let tempVal = JSON.parse(JSON.stringify(fields[index]));
    tempVal = tempArr[index-1];
    tempArr[index - 1] = tempArr[index];
    tempArr[index] = tempVal;
    setFields(tempArr);
  }

  const moveDown = (index) => {
    let tempArr = JSON.parse(JSON.stringify(fields));
    let tempVal = JSON.parse(JSON.stringify(fields[index]));
    tempVal = tempArr[index+1];
    tempArr[index + 1] = tempArr[index];
    tempArr[index] = tempVal;
    setFields(tempArr);
  }



  const handleSubmit = () => {
    if(name == '') {
      cogoToast.error('Form name is required');
      return;
    }

    let newFields = [];
    fields.map((fd, fdIdx)=>{
      if(fd.label.trim() !== '') {
        newFields.push({...fd, alert_on: fd.alert_on == 'null' ? null : fd.alert_on});
      }
    });

    if(newFields.length < 1) {
      cogoToast.error('Field labels are required');
      return;
    }
    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: name,
      description: description,
      document_number: documentNumber,
      revision_number: revisionNumber,
      revision_date: revisionDate,
      fields: newFields,
      block_id: props.filterBlock.id,
    };

    console.log('data', data);
    // return;

    setLoading(true);
    setErrors([]);
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_FORM, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/forms/index');
        cogoToast.success('Form '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
      // if(response == true) {
      // }
      // if(response.status == 200) {
      //   if(response.data == 'input') {
      //     cogoToast.error('Please check your input');
      //     setLoading(false);
      //   }
      //   else if(response.data == 'exists') {
      //     cogoToast.error('Beacon name is already taken');
      //     setLoading(false);
      //   }
      //   else {
      //     props.insertItem(response.data);
      //   }
      // }
      // else {
      //   cogoToast.error('Beacon could not be created');
      //   setLoading(false);
      // }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };


  // console.log(selectedOptions);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add' : 'Edit') : 'Add New'} Form | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Add New Form</h3>
            <Link className="btn btn-secondary" to="/forms/index">Back</Link>
          </div>


          {errors.length > 0 &&
            <div className="mt-3 mb-5">
              {errors.map((error, errorIdx) => (
                <Alert key={errorIdx} color="danger">
                  <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
                </Alert>
              ))}
            </div>
          }


            <Card>
            <CardBody>
                {/* <CardTitle tag="h3">Create</CardTitle> */}
                {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
                <div className="container">
                    <div className="mb-4 row">
                        <label htmlFor="inputName" className="col-sm-3 col-form-label label-required" required>Form Name</label>
                        <div className="col-sm-9">
                            <input autoFocus type="text" className="form-control" id="inputName" value={name} onChange={(e)=>{setName(e.target.value);}} />
                        </div>
                    </div>
                    <div className="mb-4 row">
                        <label htmlFor="inputDescription" className="col-sm-3 col-form-label">Form Description</label>
                        <div className="col-sm-9">
                            <input type="text" className="form-control" id="inputDescription" value={description} onChange={(e)=>{setDescription(e.target.value);}} />
                        </div>
                    </div>
                    <div className="mb-4 row">
                        <label htmlFor="inputDocNumber" className="col-sm-3 col-form-label">Document Number</label>
                        <div className="col-sm-9">
                            <input type="text" className="form-control" id="inputDocNumber" value={documentNumber} onChange={(e)=>{setDocumentNumber(e.target.value);}} />
                        </div>
                    </div>
                    <div className="mb-4 row">
                        <label htmlFor="inputRevisionNumber" className="col-sm-3 col-form-label">Revision Number</label>
                        <div className="col-sm-9">
                            <input type="text" className="form-control" id="inputRevisionNumber" value={revisionNumber} onChange={(e)=>{setRevisionNumber(e.target.value);}} />
                        </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="inputRevisionDate" className="col-sm-3 col-form-label">Revision Date</label>
                      <div className="col-sm-9">
                        <input type="text" className="form-control" id="inputRevisionDate"
                          type="date"
                          // defaultValue="2019-08-19"
                          value={revisionDate} onChange={e => { setRevisionDate(e.target.value); }}
                        />
                      </div>
                    </div>
                </div>
            </CardBody>
            </Card>


          <Card>
            <CardBody>
              <CardTitle tag="h3">BUILDER</CardTitle>
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              


              {fields.map((field, fieldIdx)=>(
                <div className="mb-5 d-flex align-items-center" key={fieldIdx}>
                  
                  <div className="d-flex">
                    <div className="">
                      <button type="button" disabled={fieldIdx < 1} className="btn" onClick={()=>{ moveUp(fieldIdx); }}>
                      <i className="bx bxs-up-arrow builderIcon1"></i>
                      </button>
                    </div>
                    <div className="">
                      <button type="button" disabled={fieldIdx >= fields.length-1} className="btn me-1" onClick={()=>{ moveDown(fieldIdx); }}>
                        <i className="bx bxs-down-arrow builderIcon1"></i>
                      </button>
                    </div>
                  </div>
                  <div className="flex-1  border border-secondary rounded px-2 py-3 ">
                    <div className="d-flex align-items-center mb-1">
                      <div className="ms-2 flex-1 text-muted">Label</div>
                      <div className="ms-2 flex-1 text-muted">Type</div>
                      <div className="ms-2 flex-1 text-muted">{field.type == 'radio' ? 'Options' : (field.type == 'number' ? 'Unit of Measure' :'')}</div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="ms-2 flex-1">
                        <input type="text" placeholder="Label" className="form-control" id="inputPassword" 
                          value={field.label} onChange={(e)=>{ 
                            let tempArr = JSON.parse(JSON.stringify(fields));
                            tempArr[fieldIdx].label = e.target.value;
                            setFields(tempArr);
                            }} />
                      </div>
                      <div className="ms-2 flex-1">
                        <select className="form-control" placeholder="Type" 
                          value={field.type}
                          onChange={(e)=>{ 
                            let tempArr = JSON.parse(JSON.stringify(fields));
                            tempArr[fieldIdx].type = e.target.value;
                            tempArr[fieldIdx].alert_on = 'null';
                            setFields(tempArr);
                          }}
                          >
                          <option value="text">Text</option>
                          <option value="textview">Textview</option>
                          <option value="number">Number</option>
                          <option value="radio">Radio</option>
                          <option value="remark">Remark</option>
                        </select>
                      </div>
                      <div className="ms-2 flex-1">
                        { field.type == 'radio' &&
                        <TagsInput
                          inputProps={{
                            className: 'react-tagsinput-input',
                            placeholder: 'Add options..'
                          }}
                          value={field.selectedOptions}
                          onChange={(e)=>{
                          let newFields = JSON.parse(JSON.stringify(fields));
                          newFields[fieldIdx].selectedOptions = e;
                          setFields(newFields);
                        }} />}
                        { field.type == 'number' &&
                        <input type="text" placeholder="KW, KL, Volt, Amps, etc" className="form-control" id="inputPassword" 
                        value={field.unit_of_measure} onChange={(e)=>{ 
                          let tempArr = JSON.parse(JSON.stringify(fields));
                          tempArr[fieldIdx].unit_of_measure = e.target.value;
                          setFields(tempArr);
                          }} />
                        }
                      </div>
                    </div>

                    <div className="d-flex align-items-center mt-4 mb-1">
                      <div className="ms-2 flex-1 text-muted">Field Min</div>
                      <div className="ms-2 flex-1 text-muted">Field Max</div>
                      <div className="ms-2 flex-1 text-muted">Warning Min</div>
                      <div className="ms-2 flex-1 text-muted">Warning Max</div>
                      <div className="ms-2 flex-1 text-muted">Alert on</div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className="ms-2 flex-1">
                        {field.type == 'number' ?
                        <input type="number" placeholder="" className="form-control" id="inputPassword" 
                          value={field.min} onChange={(e)=>{ 
                            let tempArr = JSON.parse(JSON.stringify(fields));
                            tempArr[fieldIdx].min = e.target.value;
                            setFields(tempArr);
                            }} /> : 
                            <div>-</div> 
                          }
                      </div>
                      <div className="ms-2 flex-1">
                        {field.type == 'number' ?
                        <input type="number" placeholder="" className="form-control" id="inputPassword" 
                          value={field.max} onChange={(e)=>{ 
                            let tempArr = JSON.parse(JSON.stringify(fields));
                            tempArr[fieldIdx].max = e.target.value;
                            setFields(tempArr);
                            }} /> : 
                            <div>-</div> 
                          }
                      </div>
                      <div className="ms-2 flex-1">
                        {field.type == 'number' ?
                        <input type="number" placeholder="" className="form-control" id="inputPassword" 
                          value={field.warning_min} onChange={(e)=>{ 
                            let tempArr = JSON.parse(JSON.stringify(fields));
                            tempArr[fieldIdx].warning_min = e.target.value;
                            setFields(tempArr);
                            }} /> : 
                            <div>-</div> 
                          }
                      </div>
                      <div className="ms-2 flex-1">
                        {field.type == 'number' ?
                        <input type="number" placeholder="" className="form-control" id="inputPassword" 
                          value={field.warning_max} onChange={(e)=>{ 
                            let tempArr = JSON.parse(JSON.stringify(fields));
                            tempArr[fieldIdx].warning_max = e.target.value;
                            setFields(tempArr);
                            }} /> : 
                            <div>-</div> 
                          }
                      </div>
                      <div className="ms-2 flex-1">
                            { field.type == 'number' &&
                            <select className="form-control" placeholder="Type" 
                              value={field.alert_on}
                              onChange={(e)=>{ 
                                let tempArr = JSON.parse(JSON.stringify(fields));
                                tempArr[fieldIdx].alert_on = e.target.value;
                                setFields(tempArr);
                              }}
                              >
                              <option value="null">No alert</option>
                              <option value="warning_max">Warning Max</option>
                              <option value="warning_min">Warning Min</option>
                              <option value="both">Both</option>
                            </select>
                            }
                            
                            { field.type == 'radio' &&
                            <select className="form-control"
                              value={field.alert_on}
                              onChange={(e)=>{ 
                                let tempArr = JSON.parse(JSON.stringify(fields));
                                tempArr[fieldIdx].alert_on = e.target.value;
                                setFields(tempArr);
                              }}
                              >
                              <option value="null">No alert</option>
                              { field.selectedOptions.map((opt, optIndex)=>(
                                <option key={optIndex} value={opt}>{opt}</option>
                              ))}
                            </select>
                            }
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <button type="button" className="btn me-2" onClick={()=>{ deleteRow(fieldIdx) }}>
                    <i className="bx bx-minus-circle builderIcon2"></i>
                    </button>
                  </div>
                </div>
              ))}

            <div className="pt-3">
              <button type="button" className="btn btn-primary me-2" onClick={()=>{ addRow(); }}>Add Field</button>
            </div>
            </CardBody>
          </Card>
          


          <div className="mb-4 container">
            <div className="d-flex justify-content-center">
              <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
              <Link className="btn btn-light" to="/forms/index">Cancel</Link>
            </div>
          </div>


        </Container>
      </div>
    </React.Fragment>
  )
}


const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewForm)